<template>
  <div class="team-members-header">
    <div class="main-container">
      <text-content-wrapper>
        <template v-slot:col-1>
          <div class="heading-2" v-html="title"></div>
        </template>
        <template v-slot:col-2>
          <div class="lead-1" v-html="description"></div>
        </template>
      </text-content-wrapper>
    </div>
  </div>
</template>

<script>
import TextContentWrapper from "/seu-frontend/sections/general/TextContentWrapper";

export default {
  name: "TeamMembersHeader",
  components: {TextContentWrapper},
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    }
  }

}
</script>

<style lang="scss">
@import "TeamMembersHeader.scss";
</style>
